/**
 * Мета данные юр. лица
 */
import { BaseModel } from '@n3/ng-api-base-kit';

export class OrganizationMeta extends BaseModel {
    public _isEmpty: boolean; /*указывает на то пустой ли объект*/
    public id: number; /*Идентификатор БД*/
    public previous_ogrn: string[]; /*Предыдущие ОГРН*/
    public description: string; /*Описание юр. лица*/

    constructor(json?: any) {
        if (json === void 0 || json === null) {
            json = {};
        }
        super();

        this.id = json.id || null;
        this.previous_ogrn = [];
        if (json.previous_ogrn) {
          for (const i in json.previous_ogrn) {
            if ( json.previous_ogrn.hasOwnProperty( i ) ) {
                this.previous_ogrn.push(json.previous_ogrn[i] || null);
            }
          }
        }
        this.description = json.description || null;
        this._isEmpty = this.isEmpty(this);
    }
}
